const baseFacottryUrlWithCors = "https://facottry-server.onrender.com/scale/get-mapping";
const baseFacottryUrlWithoutCors = "https://facottry-server.onrender.com/scale/get-mapping";
const baseFacottryUrl = baseFacottryUrlWithoutCors;


export { baseFacottryUrl };
